import { getFunctions, httpsCallable } from 'firebase/functions';
import { EVENT_TYPES, EVENT_CATEGORIES, getTypesByCategory, EventCategory } from '../constants/eventTypes.ts';

interface ClassificationInput {
  title: string;
  description: string;
}

interface ClassificationResult {
  type: string;
  category: string;
  confidence: number;
}

export const classifyEventType = async (input: ClassificationInput): Promise<string> => {
  try {
    const functions = getFunctions();
    const classifyFunction = httpsCallable<ClassificationInput, ClassificationResult>(
      functions,
      'classifyEventType'
    );

    const result = await classifyFunction(input);
    return result.data.type;
  } catch (error) {
    console.error('Error in AI classification:', error);
    return 'Other';
  }
};

// New function for detailed type classification
export const classifyEventTypeDetailed = async (input: ClassificationInput): Promise<ClassificationResult> => {
  try {
    const functions = getFunctions();
    const classifyFunction = httpsCallable<ClassificationInput, ClassificationResult>(
      functions,
      'classifyEventTypeDetailed'
    );

    const result = await classifyFunction(input);
    
    // Validate the result against our known types
    const validType = EVENT_TYPES.find(t => t.name === result.data.type);
    if (!validType) {
      // If type not found, try to find a suitable type in the suggested category
      const categoryTypes = getTypesByCategory(result.data.category as EventCategory);
      return {
        type: categoryTypes[0] || EVENT_TYPES[0].name,
        category: result.data.category || EVENT_CATEGORIES[0],
        confidence: 0.5
      };
    }

    return result.data;
  } catch (error) {
    console.error('Error in detailed AI classification:', error);
    // Return default values
    return {
      type: EVENT_TYPES[0].name,
      category: EVENT_CATEGORIES[0],
      confidence: 0
    };
  }
}; 